import { SecureAction } from '../secure-actions';

export class DeviceSparePartsSecureAction extends SecureAction {
  public static readonly VIEW: SecureAction = new DeviceSparePartsSecureAction(`settings:model:details|${SecureAction.VERBS.VIEW}`);
  public static readonly IMPORT: SecureAction = new DeviceSparePartsSecureAction(`settings:model:details|${SecureAction.VERBS.UPLOAD}`);
  public static readonly UNASSIGN_MODEL: SecureAction = new DeviceSparePartsSecureAction(
    `settings:model:details|${SecureAction.VERBS.EDIT}`,
  );
  public static readonly CREATE: SecureAction = new DeviceSparePartsSecureAction(`settings:model:details|${SecureAction.VERBS.CREATE}`);

  private constructor(name: string) {
    super(name);
  }
}
